import { render } from "./cartItem.vue?vue&type=template&id=9d2d7174&scoped=true"
import script from "./cartItem.vue?vue&type=script&lang=js"
export * from "./cartItem.vue?vue&type=script&lang=js"

import "./cartItem.vue?vue&type=style&index=0&id=9d2d7174&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d2d7174"]])

export default __exports__